import React from 'react';
import { Badge, BadgeProps, BadgeVariant, Box, Tooltip } from 'pounceV2';
import { ComplianceStatusEnum } from 'Generated/schema';

const STATUS_COLOR_MAP: { [key in StatusBadgeProps['status']]: BadgeVariant } = {
  [ComplianceStatusEnum.Pass]: 'success-outline',
  [ComplianceStatusEnum.Fail]: 'warning-outline',
  [ComplianceStatusEnum.Error]: 'error-outline',
  ENABLED: 'primary-outline',
};
interface StatusBadgeProps {
  status: ComplianceStatusEnum | 'ENABLED';
  disabled?: boolean;
  errorMessage?: string;
  disabledLabel?: string;
  size?: BadgeProps['size'];
  testId?: string;
}

const StatusBadgeV3: React.FC<StatusBadgeProps> = ({
  status,
  disabled,
  errorMessage = "An exception has been raised during a scheduled run. You'll find more information in the related details page",
  disabledLabel = 'DISABLED',
  size,
  testId,
}) => {
  const commonBadgeProps: Partial<BadgeProps> = {
    size,
    emphasized: true,
  };

  if (disabled) {
    return (
      <Box opacity={0.4}>
        <Badge {...commonBadgeProps} data-testid={testId}>
          {disabledLabel}
        </Badge>
      </Box>
    );
  }

  if (status === ComplianceStatusEnum.Error) {
    return (
      <Tooltip content={errorMessage} placement="top">
        <Box>
          <Badge {...commonBadgeProps} variant={STATUS_COLOR_MAP[status]}>
            {status}
          </Badge>
        </Box>
      </Tooltip>
    );
  }
  return (
    <Badge {...commonBadgeProps} variant={STATUS_COLOR_MAP[status]} data-testid={testId}>
      {status}
    </Badge>
  );
};

export default StatusBadgeV3;
